// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { prepareUrl } from './common';

/**
 * @class Jsw.UpgradeFailureNotification
 * @extends Jsw.Component
 */
export const UpgradeFailureNotification = Class.create(Component, {
    updateInterval: 5,

    _initConfiguration($super, config) {
        $super(config);
        this._isBootstrapRunning = this._getConfigParam('isBootstrapRunning');
        this._bootstrapExecutionUrl = this._getConfigParam('bootstrapExecutionUrl');
        this._bootstrapStatusUrl = this._getConfigParam('bootstrapStatusUrl');
        this._upgradeFailedMessage = this._getConfigParam('upgradeFailedMessage');
        this._bootstrapInProgressMessage = this._getConfigParam('bootstrapInProgressMessage');
        this._bootstrapLinkTitle = this._getConfigParam('bootstrapLinkTitle');
    },

    _initComponentElement($super) {
        $super();

        const message = this._isBootstrapRunning
            ? `<span class="ajax-loading">${this._bootstrapInProgressMessage}</span>`
            : `${this._upgradeFailedMessage} <a id="execute-bootstrap-link" href="#">${this._bootstrapLinkTitle}</a>`;

        this._componentElement.update(
            '<div class="msg-box msg-warning">' +
                '<div><div><div><div><div>' +
                    `<div class="msg-content" id="execute-bootstrap-message">${message}</div>` +
                '</div></div></div></div></div>' +
            '</div>'
        );
    },

    _addEvents($super) {
        $super();
        if (this._isBootstrapRunning) {
            this._scheduleUpdateStatus();
        } else {
            $('execute-bootstrap-link').observe('click', this._executeBootstrapper.bind(this));
        }
    },

    _executeBootstrapper() {
        new Ajax.Request(prepareUrl(this._bootstrapExecutionUrl), {
            method: 'post',
            onCreate: this._onCreateExecute.bind(this),
            onSuccess: this._scheduleUpdateStatus.bind(this),
            onFailure: this._scheduleUpdateStatus.bind(this),
        });
    },

    _onCreateExecute() {
        $('execute-bootstrap-message').update(`<span class="ajax-loading">${this._bootstrapInProgressMessage}</span>`);
    },

    _scheduleUpdateStatus() {
        this._statusUpdate.bind(this).delay(this.updateInterval);
    },

    _statusUpdate() {
        new Ajax.Request(prepareUrl(this._bootstrapStatusUrl), {
            method: 'get',
            onSuccess: this._scheduleUpdateStatus.bind(this),
            onFailure: this._scheduleUpdateStatus.bind(this),
            on0: this._scheduleUpdateStatus.bind(this),
        });
    },
});



// WEBPACK FOOTER //
// ./jsw/upgrade-failure-notification.js